import { Injectable, } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseApiService } from './base-api.service';
import { UserListModel, UserModel } from './../models';

@Injectable()
export class UserService extends BaseApiService {

    getUsers(): Observable<UserListModel[]> {
        return this.get<UserListModel[]>(`/api/users`);
    }

    getUser(id: Number): Observable<UserModel> {
        return this.get<UserModel>(`/api/user/${id}`);
    }

    saveUser(item: UserModel): Observable<number> {
        return this.post<number>(`/api/users`, item);
    }

    deleteUser(id: number): Observable<boolean> {
        return this.delete(`/api/users/${id}`);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts